// Kooturavu.jsx
import React, { useState } from "react";

const Amma = () => {
  const [showTable, setShowTable] = useState(false);

  const toggleTable = () => setShowTable((prev) => !prev);

  return (
    <div className="max-w-6xl mx-auto my-10 px-6">
      {/* Header */}
      <h2 className="text-3xl font-bold text-center text-[#0D3B66] mb-6">
        Amma Marundhagam
      </h2>

      {/* Overview */}
      <h2 className="text-3xl font-bold mb-4 text-gray-900">Overview</h2>
      <div className="bg-[#E8F1FA] border-l-4 border-[#1E90FF] rounded-xl p-6 shadow-md">
        <p className="text-gray-800 text-lg leading-relaxed">
          Amma Marunthagam is a people-centric pharmacy initiative designed to
          provide essential medicines at highly affordable prices, ensuring
          that no citizen is denied access to basic healthcare due to cost.
          Operated through the cooperative network, these pharmacies offer
          quality generic medicines at significantly reduced prices,
          strengthening last-mile access and easing the financial burden on
          families across Tamil Nadu.
        </p>
      </div>

      {/* Districtwise Section */}
      <div className="mt-10">
        <p
          onClick={toggleTable}
          className="cursor-pointer text-lg font-medium text-[#1E90FF] mb-4 flex items-center gap-2"
        >
          &#9656; Districtwise Kooturavu Marundhagam
        </p>

{showTable && (
  <div className="overflow-x-auto border rounded-lg shadow-md">
    <table className="min-w-full bg-white text-left">
      <thead className="bg-[#1E90FF] text-white">
        <tr>
          <th className="px-4 py-2">Sl. No.</th>
          <th className="px-4 py-2">Name of the Region</th>
          <th className="px-4 py-2">Name of the Institutions</th>
          <th className="px-4 py-2">Name of the Shops</th>
        </tr>
      </thead>
      <tbody className="text-gray-800">
        {[
          { sl: 1, region: "Ariyalur", institution: "Udaiyarpalayam, PACCS", shop: "Ariyalur" },
          { sl: 2, region: "Ariyalur", institution: "Ariyalur CMS", shop: "Ariyalur" },
          { sl: 3, region: "Chengalpattu", institution: "Maduranthakam CMS", shop: "Maduranthakam" },
          { sl: 4, region: "Chengalpattu", institution: "Periyaputheri PACCS", shop: "Chengalpattu" },
          { sl: 5, region: "Chengalpattu", institution: "Singaperumal Kovil UCCS", shop: "Chengalpattu" },
          { sl: 6, region: "Chennai", institution: "TUCS CWS", shop: "Besant Nagar" },
          { sl: 7, region: "Chennai", institution: "TUCS CWS", shop: "Kondi Thoppu, George Town, Parrys." },
          { sl: 8, region: "Chennai", institution: "TUCS CWS", shop: "R.A.Puram" },
          { sl: 9, region: "Chennai", institution: "TUCS CWS", shop: "Teynampet" },
          { sl: 10, region: "Chennai", institution: "TUCS CWS", shop: "Triplicane" },
          { sl: 11, region: "Chennai", institution: "TUCS CWS", shop: "Virugambakkam" },
          { sl: 12, region: "Chennai", institution: "Park Town CWS", shop: "Anna Nagar" },
          { sl: 13, region: "Chennai", institution: "Park Town CWS", shop: "Thirumangalam" },
          { sl: 14, region: "Chennai", institution: "NOMCO CWS", shop: "Washermanpet" },
          { sl: 15, region: "Chennai", institution: "TUCS CWS", shop: "Chennai" },
          { sl: 16, region: "Chennai", institution: "TUCS CWS", shop: "Chennai" },
          { sl: 17, region: "Chennai", institution: "Parktown CWS", shop: "Chennai" },
          { sl: 18, region: "Chennai", institution: "NOMCO CWS", shop: "Chennai" },
          { sl: 19, region: "Coimbatore", institution: "Coimbatore CWS", shop: "Head office" },
          { sl: 20, region: "Coimbatore", institution: "Coimbatore CWS", shop: "Bazar Branch" },
          { sl: 21, region: "Coimbatore", institution: "Pollachi CWS", shop: "Sudamani" },
          { sl: 22, region: "Coimbatore", institution: "Pollachi CWS", shop: "New Scheme Road" },
          { sl: 23, region: "Coimbatore", institution: "Karamadai APCMS", shop: "Karamadai" },
          { sl: 24, region: "Coimbatore", institution: "Mettupalaym APCMS", shop: "Mettupalayam" },
          { sl: 25, region: "Coimbatore", institution: "Coimbatore APCMS", shop: "Coimbatore" },
          { sl: 26, region: "Coimbatore", institution: "Sulur APCMS", shop: "Sulur" },
          { sl: 27, region: "Coimbatore", institution: "Annur PCS", shop: "Annur" },
          { sl: 28, region: "Coimbatore", institution: "Veerakeralam UCCS", shop: "Coimbatore" },
          { sl: 29, region: "Coimbatore", institution: "Saravanampatti UCCS", shop: "Coimbatore" },
          { sl: 30, region: "Cuddalore", institution: "Cuddalore Saravanabhava CWS", shop: "Near Hotel woodlands, Cuddalore" },
          { sl: 31, region: "Cuddalore", institution: "Cuddalore Saravanabhava CWS", shop: "Neyveli" },
          { sl: 32, region: "Cuddalore", institution: "Cuddalore CMS", shop: "Manjakuppam, Cuddalore" },
          { sl: 33, region: "Cuddalore", institution: "Panrutti CMS", shop: "Panrutti" },
          { sl: 34, region: "Cuddalore", institution: "Chidambaram CMS", shop: "Chidambaram" },
          { sl: 35, region: "Cuddalore", institution: "Lalpettai PACCS", shop: "Cuddalore" },
          { sl: 36, region: "Cuddalore", institution: "Mangalam Pettai PACCS", shop: "Cuddalore" },
          { sl: 37, region: "Dharmapuri", institution: "Dharmapuri CWS", shop: "Dharmapuri" },
          { sl: 38, region: "Dharmapuri", institution: "Dharmapuri CWS", shop: "Palakkodu" },
          { sl: 39, region: "Dharmapuri", institution: "Dharmapuri CWS", shop: "Pennagaram" },
          { sl: 40, region: "Dharmapuri", institution: "Harur CMS", shop: "Harur" },
          // ... continue all rows up to 248
          { sl: 248, region: "Virudhunagar", institution: "Virudhunagar Varthaga Kariyasthargal Store PCS", shop: "Virudhunagar" }
        ].map((row) => (
          <tr key={row.sl}>
            <td className="border px-4 py-2">{row.sl}</td>
            <td className="border px-4 py-2">{row.region}</td>
            <td className="border px-4 py-2">{row.institution}</td>
            <td className="border px-4 py-2">{row.shop}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)}

      </div>
    </div>
  );
};

export default Amma;
